// Sizes generated by the Firebase "Resize Images" extension. Copies are stored
// next to the original (no subfolder) and named `{originalFileName}_{size}`
// with no file extension, because our originals are uploaded without one.
export const PRODUCT_IMAGE_SIZES = {
  LIST: "200x200",
  PREVIEW: "800x800",
};

// Builds the public URL of a resized copy from the original image's stored
// download URL. The resized files are made public by the extension, so the URL
// is deterministic and needs no token. Returns the original URL on failure
export function buildResizedUrl(originalUrl, size) {
  if (!originalUrl) {
    return originalUrl;
  }

  try {
    const { pathname } = new URL(originalUrl);
    const bucket = pathname.split("/")[3];
    const path = decodeURIComponent(pathname.match(/\/o\/(.+)$/)[1]);
    return `https://storage.googleapis.com/${bucket}/${path}_${size}`;
  } catch {
    return originalUrl;
  }
}
